import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@telegram-apps/telegram-ui/dist/styles.css';
import './styles/global.css';
import { App } from './App';
import { initTelegram } from './lib/telegram';

// Инициализация до рендера: ready() снимает скелетон Telegram, а themeParams
// должны попасть в CSS-переменные раньше первого кадра, иначе будет вспышка
// светлой темы на тёмном клиенте.
initTelegram();

const container = document.getElementById('root');

if (!container) {
  throw new Error('#root не найден в index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
